/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Origin_KickerInputs */

const en_road_dude_origin_kicker = /** @type {(inputs: Road_Dude_Origin_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`THE ORIGIN`)
};

const zh_road_dude_origin_kicker = /** @type {(inputs: Road_Dude_Origin_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原梗出处`)
};

/**
* | output |
* | --- |
* | "THE ORIGIN" |
*
* @param {Road_Dude_Origin_KickerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_origin_kicker = /** @type {((inputs?: Road_Dude_Origin_KickerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Origin_KickerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_origin_kicker(inputs)
	return zh_road_dude_origin_kicker(inputs)
});
export { road_dude_origin_kicker as "road_dude.origin.kicker" }